function Explore({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.14808 16.8516L4.23656 15.2651L5.05578 14.4459L7.46923 14.7959L11.4942 10.7709L3.91541 6.65551L4.98846 5.57283L14.2885 7.9459L17.723 4.53248C17.9615 4.29403 18.2531 4.1748 18.598 4.1748C18.9429 4.1748 19.2345 4.29403 19.473 4.53248C19.7115 4.77095 19.8307 5.06421 19.8307 5.41228C19.8307 5.76035 19.7115 6.05361 19.473 6.29208L16.0634 9.72088L18.4269 19.0113L17.3538 20.0939L13.2288 12.5151L9.22306 16.5209L9.56343 18.9439L8.73461 19.7728L7.14808 16.8516Z" />
    </svg>
  );
}

export default Explore;
